import { useState } from "react";

import { BillingProfileContactInformationStep } from "./BillingProfileContactInformationStep";
import { BillingProfileInformationStep } from "./BillingProfileInformationStep";
import {
  initialBillingProfileValues,
  BillingProfile,
  CreateBillingProfileContext,
} from "../CreateBillingProfileContext";

export function CreateBillingProfilePage() {
  const [billingProfile, setBillingProfile] = useState<BillingProfile>(
    initialBillingProfileValues
  );
  const [formHasData, setFormHasData] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    <BillingProfileInformationStep key="BillingProfileInformationStep" />,
    <BillingProfileContactInformationStep key="BillingProfileContactInformationStep" />,
  ];

  const handleNext = () => {
    setCurrentStep((curr) => curr + 1);
  };

  const handlePrev = () => {
    setCurrentStep((curr) => curr - 1);
  };

  return (
    <CreateBillingProfileContext.Provider
      value={{
        billingProfile,
        setBillingProfile,
        goToNextStep: handleNext,
        goToPrevStep: handlePrev,
        currentStep,
        formHasData,
        setFormHasData,
      }}
    >
      {steps[currentStep]}
    </CreateBillingProfileContext.Provider>
  );
}
